import type {
  UserCalculateFiatDepositCostInput,
  UserPaymentInitiateFiatDepositInput,
  UserPaymentVerifyFiatDepositInput,
  UserGetFiatTransactionHistoryInput,
  UserFiatWithdrawInput,
  UserCancelFiatWithdrawalInput,
  UserCalculateWithdrawalCostInput,
  UserInitiateCryptoDepositInput,
  UserGetAvailableCryptoContractsParams,
} from '../api'
import { api } from '../api'
import { delayFn } from '../delay'

const paymentInitiateDepositFiat = async (
  data: UserPaymentInitiateFiatDepositInput,
) => {
  return await api.v1.userPaymentInitiateFiatDeposit({
    ...data,
  })
}

const userGetAvailableCryptoContracts = async (
  data: UserGetAvailableCryptoContractsParams,
) => {
  return await api.v1.userGetAvailableCryptoContracts(data)
}

const initiateCryptoDepositInput = async (
  data: UserInitiateCryptoDepositInput,
) => {
  return await api.v1.userInitiateCryptoDeposit({
    ...data,
  })
}
const initiateWithdrawalFiat = async (data: UserFiatWithdrawInput) => {
  await api.v1.userInitiateFiatWithdrawal({
    ...data,
  })

  return await delayFn(2000)
}
const paymentVerifyDepositFiat = async (
  data: UserPaymentVerifyFiatDepositInput,
) => {
  return await api.v1.userPaymentVerifyFiatDeposit({
    ...data,
  })
}
const calculateDepositCost = async (
  data: UserCalculateFiatDepositCostInput,
) => {
  return await api.v1.userCalculateFiatDepositCost({
    ...data,
  })
}
const calculateWithdrawalCost = async (
  data: UserCalculateWithdrawalCostInput,
) => {
  return await api.v1.userCalculateWithdrawalCost({
    ...data,
  })
}
const getFiatTransactionHistory = async (
  data: UserGetFiatTransactionHistoryInput,
) => {
  return await api.v1.userGetFiatTransactionHistory({
    ...data,
  })
}
const cancelWithdrawalFiat = async (data: UserCancelFiatWithdrawalInput) => {
  return await api.v1.userCancelFiatWithdrawal({
    ...data,
  })
}

export default {
  paymentInitiateDepositFiat,
  paymentVerifyDepositFiat,
  calculateDepositCost,
  calculateWithdrawalCost,
  getFiatTransactionHistory,
  initiateWithdrawalFiat,
  cancelWithdrawalFiat,
  initiateCryptoDepositInput,
  userGetAvailableCryptoContracts,
}
